import React from "react";
import ReactDOM from "react-dom";
import styled from "@emotion/styled";

const GenericModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <ModalOverlay>
      <ModalWrapper>
        <Frame1392 onClick={onClose}>
          <IconFrame>
            <IconFilled
              src="https://d3nakrlcog1u3z.cloudfront.net/1751292506524-search.svg"
              alt="icon"
            />
          </IconFrame>
        </Frame1392>
        <ModalContent>{children}</ModalContent>
      </ModalWrapper>
    </ModalOverlay>,
    document.getElementById("modal-root")
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding-inline: 16px;
`;

const ModalWrapper = styled.div`
  background: #fff;
  border-radius: 32px;
  max-width: 100%;
  z-index: 1001;
  position: relative;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  overflow: hidden;
`;

const ModalContent = styled.div`
  text-align: center;
  max-height: 80vh;
  overflow-y: auto  ;
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

const Frame1392 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  height: 1px;
  box-sizing: border-box;
  flex-shrink: 0;
  position: absolute;
  top: 24.5px;
  right: 24px;
  cursor: pointer;
  z-index: 99;

`;

const IconFilled = styled.img`
  width: 10.008px;
  height: 10.008px;
  flex-shrink: 0;
  object-fit: cover;
`;

const IconFrame = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  opacity: 0.8;
  background: var(--Color-Backgound-Dark---10, #212543);
`;

export default GenericModal;
